<script>
	import tool from '@/utils/tool.js'
	import { setSentryUser } from '@/utils/sentry.js'
	import { getCurrentUserInfo, isUserLoggedIn } from '@/utils/user.helper.js'
	
	export default {
		onLaunch: function() {
			console.log('App Launch')
			
			// 应用启动时，如果用户已登录，自动设置 Sentry 用户信息
			if (isUserLoggedIn()) {
				const userInfo = getCurrentUserInfo()
				if (userInfo) {
					setSentryUser(userInfo)
					console.log('[App] Sentry 用户信息已设置:', userInfo.phone)
				}
			}
		},
		onShow: function() {
			tool.checkToken()
			console.log('App Show')
			
			// 每次应用显示时，检查并更新用户信息
			if (isUserLoggedIn()) {
				const userInfo = getCurrentUserInfo()
				if (userInfo) {
					setSentryUser(userInfo)
				}
			}
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style>
	@import "./uni_modules/vk-uview-ui/index.scss";

	/*每个页面公共css */
	page {
		background-color: #eee;
	}

	.p26rpx {
		padding: 26rpx;
	}
	
	.u-subsection{
		background-color: #fff !important;
	}
	.white-bg {
		background-color: #fff;
	}
	.bg-eee{
		background-color: #eee;
	}
	.form-btns {
		/* position: fixed; */
		bottom: 0;
		left: 0;
		width: 100%;

		.btns {
			border: 0 !important;
			border-radius: 10 !important;

		}
	}

	.two-line-clamp {
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}

	.one-line-clamp {
		overflow: hidden;
		-webkit-line-clamp: 1;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}
</style>